// Simple localStorage-backed offline mutation queue.
// Designed for appointment status updates while offline; flushes when online.
import { toast } from 'sonner';

const KEY = 'therapyops:offlineQueue';

function read() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (_) { return []; }
}

function write(items) {
  try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (_) { /* quota */ }
}

export function enqueue(action) {
  const items = read();
  items.push({ ...action, id: `q_${Date.now()}_${Math.random().toString(36).slice(2,8)}`, created_at: new Date().toISOString() });
  write(items);
  return items.length;
}

export function size() {
  return read().length;
}

export function peek() {
  return read();
}

export function clear() {
  write([]);
}

// processor: async (action) => true on success, false to keep
export async function flush(processor) {
  const items = read();
  if (!items.length) return { processed: 0, remaining: 0 };
  const remaining = [];
  let processed = 0;
  for (const item of items) {
    try {
      const ok = await processor(item);
      if (ok) processed += 1; else remaining.push(item);
    } catch (_) {
      remaining.push(item);
    }
  }
  write(remaining);
  if (processed > 0) {
    toast.success(`Synced ${processed} offline change${processed === 1 ? '' : 's'}`);
  }
  return { processed, remaining: remaining.length };
}
